import styled from 'styled-components';

import { BaseCard } from './BaseCard';

import { colors, breakpoints } from '../../constants';

interface IProps {
    position: {
        top: number;
        left: number;
        width: number;
        height: number;
    };
}

export const BackgroundCardWrapper = styled(BaseCard)<IProps>`
    background-color: ${colors.swipeDefault};
    position: absolute;
    top: ${(props) => props.position.top}px;
    left: ${(props) => props.position.left}px;
    width: ${(props) => props.position.width}px;
    height: ${(props) => props.position.height}px;

    @media (${breakpoints.mediumMin}) {
        display: none;
    }
`;
